import React from 'react'
import styled from '@emotion/styled'
import SVGLoader from '@src/components/svg/SVGLoader'

type PropsType = {
	color: string
	className?: string
	style?: React.CSSProperties
} & React.SVGProps<SVGSVGElement> &
	React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

type SVGStyleType = {
	color: string
}

const QuestionMarkIcon = ({ color, className, style, ...rest }: PropsType) => {
	return (
		<IconBlock {...rest}>
			<QuestionMark name="questionMark" color={color} className={className} style={style} />
		</IconBlock>
	)
}

const IconBlock = styled.div`
	display: inline-block;
	vertical-align: middle;
	margin-left: 0.3rem;
`

const QuestionMark = styled(SVGLoader)<SVGStyleType>`
	color: ${(props) => props.color};
`

export default QuestionMarkIcon
